import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";
import { BetweenDates } from "../Betweendates";

export default function ApplicationDate({ searchObject, setSearchObject, t }) {
  return (
    <>
      <div>
        <legend className="fontsize-legend">{t("Application date")}</legend>
        <BetweenDates
          setObeject={setSearchObject}
          dateObject={searchObject}
          dateEndField="ApplicationDateEnd"
          dateStartField="ApplicationDateStart"
        />
      </div>
    </>
  );
}
